import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SubscriberService } from 'src/app/services/manager/subscriber.service';
import { ModalController } from '@ionic/angular';
import { Address } from 'src/app/interfaces/orders';

@Component({
  selector: 'app-change-address',
  templateUrl: './change-address.component.html',
  styleUrls: ['./change-address.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeAddressComponent  implements OnInit {

  data: any;

  address: any = {
    name: '',
    street: '',
    city: '',
    zip: '',
    countryCode: '',
  };

  deliveryAddress: any = {
    companyName: '',
    contactPerson: '',
    supplement: '',
    street: '',
    zip: '',
    city: '',
  };

  constructor(
    private modalCtrl: ModalController,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.address = this.data.data;
    
    // Load delivery address from customerBase if available
    if (this.data.customerBase?.delivery) {
      this.deliveryAddress = { ...this.data.customerBase.delivery };
    }
    
    this.cdr.markForCheck();
  }

  back() {
    this.modalCtrl.dismiss();
  }

  confirm() {
    this.modalCtrl.dismiss();
  }

  onSaved() {
    const result = {
      address: this.address,
      deliveryAddress: this.deliveryAddress
    };
    this.sendBackData(result);
  }

  sendBackData(data: any = null) {
    this.modalCtrl.dismiss(data);
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }


}
